import BaseAPI from "../base";

function uploadImage(img, type, is_large) {
  let fd = new FormData();
  fd.append("image", img);
  fd.append("type", "product");
  fd.append("is_large", is_large);

  let path = "/media/upload";

  if (type == "cafe") path = "/media/uploadCafeLogo";
  if (type == "avatar") path = "/media/uploadAvatar";
  if (type == "misc") path = "/media/uploadMisc";
  if (type == "editor") path = "/media/uploadEditorOriginal";

  return BaseAPI.root.post(path, fd, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function editPhoto(url, identity, widescreen) {
  return BaseAPI.post(`/media/edit_photo`, {
    url,
    identity,
    widescreen,
  });
}

function getLastPipelines(url) {
  return BaseAPI.get(`/media/photo_editor_pipelines`, {
    url,
  });
}

function setLastPipelines(url, pipelines) {
  return BaseAPI.post(`/media/photo_editor_pipelines`, {
    url,
    pipelines,
  });
}

function generateUploadUrl(resource_type, file_type) {
  return BaseAPI.post(`/media/generateUploadUrl`, {
    resource_type,
    file_type,
  });
}

export default {
  uploadImage,
  editPhoto,
  getLastPipelines,
  setLastPipelines,
  generateUploadUrl,
};
